<template lang="pug">
    div.InteractiveCalendar(v-if="currentStep.data")
      lessonHeader(@prev="prev" :onlyFather="true")
      stepTitle                
      div.intro(v-show="currentIndex === 0")
        | {{ currentStep.initialText }}
      v-card.card1(flat v-show="currentIndex === 0")      
        v-layout(row)
          v-flex.gutter(shrink pa-1)                  
            img.init-img(src="@/assets/TDC-L2-6-Pagina2 B.png")
          v-flex.gutter(grow pa-1)
              div.label-ic Fecha de corte
              v-menu(
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy 
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  )                    
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="currentStep.data.cutdate"                                                
                      readonly
                      v-on="on")          
                  v-date-picker(v-model="currentStep.data.cutdate" @input="changeCutDate")                  
          v-flex.gutter(shrink pa-1)
             v-card(flat)
              el-button.lp(
                type="success"
                :disabled="!currentStep.data.cutdate"
                @click="changeIndex") Calcular límite de pago
      v-card.card1(flat v-show="currentIndex === 1")      
        v-layout(row)
          v-flex.gutter(xl6 lg6)
            div.text-sm-left.acro-container
              v-layout(row)
                v-flex.gutter(xl1 lg1)
                  v-avatar(color="#EFDDAC")
                v-flex.gutter(xl18 lg18)
                  div.acro Fecha de corte              
            div.text-sm-left.acro-container
              v-layout(row)
                v-flex.gutter(xl1 lg1)
                  v-avatar(color="#B1D190")
                v-flex.gutter(xl18 lg18)
                  div.acro Fecha límite de pago              
            div.text-sm-left.acro-container
              v-layout(row)
                v-flex.gutter(xl1 lg1)
                  v-avatar(color="#E3D6E7")
                v-flex.gutter(xl18 lg18)
                  div.acro Periodo para hacer compras
            div.text-sm-left.acro-container
              v-layout(row)
                v-flex.gutter(xl1 lg1)
                  v-avatar(color="#4FBFEB")
                v-flex.gutter(xl18 lg18)
                  div.acro Mejores días para realizar tus compras. Financiamiento de 45 a 50 días
            div.text-sm-left.acro-container
              v-layout(row)
                v-flex.gutter(xl1 lg1)
                  v-avatar(color="#6b4946")
                v-flex.gutter(xl18 lg18)
                  div.acro Hoy
          v-flex.gutter(xs6)
            calendar(v-if="currentStep.data.cutdate" :interac="false" :eventCategories="eventCategories" :events="events")
      feedbackModal(@next="nextButton")
      lessonFooter
</template>

<script>

import stepTitle from '@/components/step-title/step-title'
import initialText from '@/components/initial-text/initial-text'
import calendar from "@/components/calendar/calendar";
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import lessonHeader from "@/components/lesson-header/lesson-header";
import DateTime from '@/utils/DateTime'
import feedbackModal from "@/components/feedback-modal/feedback-modal";
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'InteractiveCalendar',
  components:{
    stepTitle,    
    calendar,
    lessonFooter, 
    lessonHeader,
    feedbackModal
  },
  data() {
    const vm = this;
    const cutdate = () => {
      if(vm.$store.getters.currentStep.data.cutdate)      
        return vm.$store.getters.currentStep.data.cutdate.toString();
    };
    return {
      menu: false,
      currentIndex: 0,
      eventCategories: [
        {
          id: 1,
          title: 'Fecha de corte',          
          backgroundColor: '#EFDDAC'
        },
        {
          id: 2,
          title: 'Limite de pago',          
          backgroundColor: '#B1D190'
        },
        {
          id: 3,
          title: 'Compras', 
          isRange: true,         
          backgroundColor: '#E3D6E7'
        },
        {
          id: 4,
          title: 'Mejores compras', 
          isRange: true,
          backgroundColor: '#E3D6E7',
          borderBottom: '3px solid #4FBFEB'
        }
      ],
      events: [
        {
          title: 'Fecha de corte',
          start:  '2019-05-12' ,
          end: '2019-05-12',
          repeat: 'monthly',
          categoryId: 1
        },
        {
          title: 'Limite de pago',
          start: '2019-05-08',
          end: '2019-05-09',
          repeat: 'monthly',
          categoryId: 2
        },
        {
          title: 'Compras',
          start: '2019-05-10',
          end: '2019-05-11',
          repeat: 'monthly',
          categoryId: 3
        },
        {
          title: 'Compras',
          start: '2019-05-10',
          end: '2019-05-11',
          repeat: 'monthly',
          categoryId: 3
        },
        {
          title: 'Mejores Compras',
          start: '2019-05-10',
          end: '2019-05-11',
          repeat: 'monthly',
          categoryId: 4
        },
        {
          title: 'Mejores Compras Complemento',
          start: null,
          end: null,
          repeat: 'monthly',
          categoryId: 4
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['currentStep', 'currentGroup'])
  },  
  methods: {
    ...mapMutations(['setEvents', 'setCurrentStep']),
    changeCutDate(date) {
      
      this.currentStep.data.cutday = new DateTime(date).getNextDay().getDate();

      let day = new DateTime(date).getNextDay().toDateString();
      this.menu = false
      this.events[0].start = day;
      this.events[0].end = day;
      
      day = new DateTime(date).addDays(21).toDateString();
      this.events[1].start = day;
      this.events[1].end = day;
            
      const month = new DateTime(date).getMonth();
      const year = new DateTime(date).getFullYear();
      day = new Date(year, month, 0);

      this.events[2].start = new DateTime(date).getNextDay().toDateString();
      this.events[2].end = day;

      day = new Date(year, month, 1);

      this.events[3].start = day;
      this.events[3].end = new DateTime(date).getNextDay().toDateString();

      day = new DateTime(date).getNextDay().getNextDay();
      this.events[4].start = day.toDateString();

      if (day.addDays(4).getMonth() !== day.getMonth()) {
        this.events[4].end = new Date(year, month, 0);        
        day = new DateTime(new Date(year, month, 1));
        this.events[5].start = day.toDateString();
        this.events[5].end = day.addDays(3).toDateString();
      } else {
        this.events[4].end = day.addDays(4).toDateString();
        this.events[5].start = day.toDateString();
        this.events[5].end = day.addDays(4).toDateString();
      }
            
    },
    changeIndex() {
      this.currentIndex++;
      this.currentStep.answered = true;
      this.currentStep.check = false;
      this.currentStep.check = true;
    },
    nextButton() {
      this.currentIndex = 0;
      // this.currentStep.answered = true;
      // this.currentStep.check = true;
    },
    prev() {
      if(this.currentIndex !== 0) {
        this.currentIndex = 0;
      } else {
        const step = this.currentGroup.steps[this.currentStep.index - 1];       
        this.setCurrentStep(step);        
      }
      
      this.currentStep.answered = false;
      this.currentStep.check = false;
    }
  }
}
</script>

<style scoped>
@import 'interactive-calendar.scss';
</style>